import { observer } from 'mobx-react-lite';
import { Button } from '../../../buttons/button';
import { BasicLoader } from '../../../loaders/basic-loader';
import { PopupStore } from '../../popup.store';

export const PaymentRefresh = observer<{ popupStore: PopupStore; styles: { [key: string]: string } }>(({ popupStore, styles }) => {
  return (
    <>
      <h4 className="cust-my-4">
        <i className="text-warning icon-warning h1 cust-pr-1" />
        Payment In progress
      </h4>

      <h4 className="cust-my-4">Request Timed Out</h4>
    </>
  );
});